/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1UserUseridDefaultPasswordMutationRequest,
  PostApiV1UserUseridDefaultPasswordMutationResponse,
  PostApiV1UserUseridDefaultPasswordPathParams,
  PostApiV1UserUseridDefaultPassword400,
  PostApiV1UserUseridDefaultPassword401,
  PostApiV1UserUseridDefaultPassword500,
} from "../../types/userCredenciaisController/PostApiV1UserUseridDefaultPassword.ts";

function getPostApiV1UserUseridDefaultPasswordUrl(
  userId: PostApiV1UserUseridDefaultPasswordPathParams["userId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/user/${userId}/default-password` as const,
  };
  return res;
}

/**
 * @description Redefine a senha permanente do usuário para o valor informado (ou para a senha padrão configurada na empresa do operador, se houver). A senha é criptografada, o campo ChangePassword é marcado como verdadeiro e a alteração é propagada para o SSO. Valida permissão de empresa do operador sobre o usuário alvo. Operadores com perfil Seller ou SellerManager não podem redefinir senhas de usuários com perfil diferente de Básico. **(Requer Authorization para autenticação)**
 * @summary Redefinir senha padrão do usuário (Requer Authorization para autenticação)
 * {@link /api/v1/user/:userId/default-password}
 */
export async function postApiV1UserUseridDefaultPassword(
  userId: PostApiV1UserUseridDefaultPasswordPathParams["userId"],
  data?: PostApiV1UserUseridDefaultPasswordMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1UserUseridDefaultPasswordMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1UserUseridDefaultPasswordMutationResponse,
    ResponseErrorConfig<
      | PostApiV1UserUseridDefaultPassword400
      | PostApiV1UserUseridDefaultPassword401
      | PostApiV1UserUseridDefaultPassword500
    >,
    PostApiV1UserUseridDefaultPasswordMutationRequest
  >({
    method: "POST",
    url: getPostApiV1UserUseridDefaultPasswordUrl(userId).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
